import styled from "styled-components";

export const CmpYesNoList = styled.div`
  /* border-radius: 10px;
  margin-bottom: ${({last}) => last ? '' : '5px'};
  justify-content: space-between; */
  .input-container {
    width: fit-content;
  }
  .list-states {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${ ({disabled}) => !disabled ? '#F0F0FF' : '#CFD3DD'};
    border-radius: 20px;
    .state-separator {
      border-right: 1px solid #CFD3DD;
      margin: 0 10px;
      height: 14px;
    }
    .state {
      margin: 5px;
      cursor: ${ ({disabled}) => !disabled ? 'pointer' : 'deafult'}; 
      height: 40px;
      border-radius: 20px;
      width: 89.5px;
      font-family: "Nunito Sans";
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;   
      font-size: 18px;
      background-color: transparent;
      color: ${ ({disabled}) => !disabled ? '#2A28D6' : '#3E3E5B'}; 
      &--selected {
        color: white;
        background-color: #6C6BF5;    
        box-shadow: -8px -7px 15.3px -6px #5554F033;
        box-shadow: 10px 6px 9.5px -6px #FFFFFF;
        box-shadow: -5px -4px 6.6px -4px #FFFFFF40 inset;
      }
    }
  }
`
